module.exports = __webpack_public_path__ + "img/team_natascha.ba347f10.jpg";